// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"7bee4107","703":"d47a3311"}[chunkId] + ".chunk.js";
};